import $ from 'jquery';

// 1000ms = 1s
const transitionDuration = 1000;
function Carousel($el) {
  const $this = this;

  $this.module = $el;

  $this._minScale = 0.6;
  $this._minOffset = 0.5;
  $this._breakpoints = {
    ph: window.matchMedia('(min-width: 480px)'),
    md: window.matchMedia('(min-width: 768px)'),
    bg: window.matchMedia('(min-width: 1024px)'),
    lg: window.matchMedia('(min-width: 1280px)'),
    xl: window.matchMedia('(min-width: 1440px)'),
  };
  $this.settings = {
    auto: {
      play: true,
      time: 5000,
      interval: null,
    }
  };

  $this.data = [];

  $this.initAutoPlay = function() {
    if ($this.settings.auto.play) {
      $this.startAuto();
    } else {
      $this.stopAuto();
    }

    $this.module.hover(function() {
      if ($this.settings.auto.interval) {
        $this.stopAuto();
        $this.settings.auto.autoPaused = true;
      }
    }, function() {
      if ($this.settings.auto.autoPaused) {
        $this.startAuto();
        $this.settings.auto.autoPaused = null;
      }
    });

    $(window)
      .focus(function() { $this.startAuto(); })
      .blur(function() { $this.stopAuto(); });
  };

  $this.startAuto = function() {
    if ($this.settings.auto.interval) { return; }

    $this.settings.auto.interval = setInterval(function() {
      $this.goToNextCard();
    }, $this.settings.auto.time);
  };

  $this.stopAuto = function() {
    if (!$this.settings.auto.interval) { return; }

    clearInterval($this.settings.auto.interval);
    $this.settings.auto.interval = null;
  };

  $this.setElements = function() {
    $this.container = $this.module.find('.module--b7--cards');
    $this.cardsWrapper = $this.module.find('.module--b7--cards');
    $this.cards = $this.module.find('.module--b7--card');
    $this.bodysWrapper = $this.module.find('.module--b7--bodys');
    $this.bodys = $this.module.find('.module--b7--body');

    $this.cards.each(function(index, card) {
      card.originalID = index;
    });
  };

  $this.getData = function() {
    $this.data = $this.cards.map(function(index, card) {
      return {
        'order': index - $this.sideQty,
        'width': $(card).width()
      };
    }).toArray();
  };

  $this.setContainerHeight = function() {
    const heights = $this.cards.toArray().map(card => $(card).height());
    $this.container.height(Math.max(...heights));
  };

  $this.setVars = function() {
    $this.cardWidth = $this.cards.first().outerWidth();
    $this.scaleStep = (1 - $this._minScale) / $this.sideQty;
    $this.availableSideSpace = ($this.module.width() - $this.cardWidth) / 2;
    $this.reduceOffsetBase = $this.availableSideSpace < $this.spaceRequired() ? $this.additionalOffset() : 0;
    $this.setMode();
  };

  $this.spaceRequired = function() {
    return $this.cardWidth * ($this.APS(1, -1 * $this.scaleStep, $this.sideQty + 1) - 1) / 2;
  };

  $this.additionalOffset = function() {
    return ($this.spaceRequired() - $this.availableSideSpace) / ($this.APS(1, -1 * $this.scaleStep, $this.sideQty + 1) - 1);
  };

  /**
   * Arithmetic progression sum
   * @param {Number} a first term of arithmetic sequence
   * @param {Number} d difference between terms
   * @param {Number} n number of terms
   */
  $this.APS = function(a, d, n) {
    return (2 * a + d * (n - 1)) * n / 2;
  };

  $this.rotateCardsForward = function() {
    const cards = $this.cards.toArray();
    cards.push( cards.shift() );
    $this.cards = $(cards);
  };

  $this.rotateCardsBackward = function() {
    const cards = $this.cards.toArray();
    cards.unshift( cards.pop() );
    $this.cards = $(cards);
  };

  $this.getActiveCard = function() {
    return $this.cards.eq( $this.sideQty );
  };

  $this.getCardsBeforeActive = function() {
    return $( $this.cards.toArray().slice(0, $this.sideQty).reverse() );
  };

  $this.getCardsAfterActive = function() {
    return $this.cards.slice($this.sideQty + 1);
  };

  $this.setCardsPosition = function() {
    const activeCard = $this.getActiveCard();
    const cardsBefore = $this.getCardsBeforeActive();
    const cardsAfter = $this.getCardsAfterActive();

    activeCard
      .css( $this.cssTransform(1) )
      .css('z-index', $this.sideQty + 1);

    cardsBefore.each((i, el) => {
      const card = $(el);
      const cardStyles = $this.cardStyles(i, -1);

      card.css( cardStyles );
    });

    cardsAfter.each((i, el) => {
      const card = $(el);
      const cardStyles = $this.cardStyles(i);

      card.css( cardStyles );
    });
  };

  $this.setCardsOffset = function() {
    $this.cards.each(function(index, el) {
      const $card = $(this);
      $card.css({
        left: `calc(50% - ${$card.width() / 2}px)`,
        top: `calc(50% - ${$card.height() / 2}px)`,
      });
    });
  };

  $this.goToNextCard = function() {
    $this.rotateCardsForward();
    $this.cards.removeClass('active');
    $this.getActiveCard().addClass('active');
    $this.setCardsPosition();

    $this.bodys.removeClass('active');
    $this.getActiveBody().addClass('active');
  };

  $this.goToPrevCard = function() {
    $this.rotateCardsBackward();
    $this.cards.removeClass('active');
    $this.getActiveCard().addClass('active');
    $this.setCardsPosition();

    $this.bodys.removeClass('active');
    $this.getActiveBody().addClass('active');
  };

  $this.clickHandler = function() {
    const index = $this.cards.index(this);
    const rounds = Math.abs(index - $this.sideQty);

    for (let i = 0; i < rounds; i++) {
      setTimeout(() => {
        index > $this.sideQty ? $this.goToNextCard() : $this.goToPrevCard();

        if (i == rounds - 1) {
          dataLayer.push({
            'event': 'gtm.click',
            'gtm.element': $this.getActiveBody().find('h2').toArray().pop(),
          })
        }
      }, i * 400);
    }
  };

  $this.initEventHandlers = function() {
    $this.cards.click($this.clickHandler);

    Object.keys($this._breakpoints).forEach((key) => $this._breakpoints[key].addListener((mq) => {
      $this.setVars();
      $this.setCardsPosition();
      $this.setContainerHeight();
      $this.setCardsOffset();
      $this.setBodysHeight();
    }));
  };

  $this.setMode = function() {
    if ($this._breakpoints.lg.matches) {
      $this._mode = 'advanced';
    } else if ($this._breakpoints.md.matches) {
      $this._mode = 'mixed';
    } else {
      $this._mode = 'simple';
    }
  };

  $this.getMode = function() {
    return $this._mode;
  }

  $this.cardScale = function(index) {
    switch($this._mode) {
      case 'advanced':
        return 1 - $this.scaleStep * (index + 1);
      case 'mixed':
        return 0.8;
      default:
        return 1;
    }
  };

  $this.cardTransform = function(index) {
    if (index < 0) return 0;

    switch($this._mode) {
      case 'advanced':
        const prevMove = $this.cardTransform(index - 1) * $this.cardScale(index - 1) / $this.cardScale(index);
        const prevWidth = $this.cardWidth * $this.cardScale(index - 1);
        const currentWidth = $this.cardWidth * $this.cardScale(index);

        return prevMove + (((prevWidth - currentWidth) / 2) + $this._minOffset * currentWidth - $this.reduceOffsetBase * $this.cardScale(index)) / $this.cardScale(index);
      case 'mixed':
        return (index + 1) * ($this.cardWidth * 0.2 / 2 + 70 + $this.cardWidth * 0.8) / 0.8;

      default:
        return (index + 1) * ($this.cardWidth + 30);
    }
  };

  $this.cardZIndex = function(index) {
    return $this.sideQty - index;
  };

  $this.cardStyles = function(i, flip = 1) {
    return jQuery.extend(
      {},
      $this.cssZIndex( $this.cardZIndex(i) ),
      $this.cssTransform($this.cardScale(i), flip * $this.cardTransform(i))
    );
  };

  $this.setIndex = function(index) {
    $this._index = index;
  };

  $this.getIndex = function() {
    return $this._index !== undefined ? $this._index : Math.floor($this.cards.length / 2);
  };

  $this.getActiveBody = function() {
    return $this.bodys.eq( $this.getActiveCard()[0].originalID );
  };

  $this.cssTransform = function(scale, translate) {
    const rule = 'transform';
    const value = [scale ? `scale(${scale})` : '', translate ? `translateX(${translate}px)` : '', ].join(' ');
    const prefixes = ['-webkit-', '-ms-', ''];
    const styles = {};

    prefixes.forEach(prefix => { styles[prefix + rule] = value} );

    return styles;
  };

  $this.cssZIndex = function(zindex) {
    return { 'z-index': zindex };
  };

  $this.setBodysHeight = function() {
    const heights = $this.bodys.toArray().map(body => $(body).height());

    $this.bodysWrapper.height( Math.max(...heights) );
  };

  $this.init = function() {
    $this.setElements();
    $this.sideQty = Math.floor($this.cards.length / 2);
    // $this.getData();
    $this.setContainerHeight();
    $this.setCardsOffset();
    $this.setVars();
    $this.setCardsPosition();
    $this.getActiveCard().addClass('active');
    $this.getActiveBody().addClass('active');
    $this.setBodysHeight();

    $this.initEventHandlers();
    $this.initAutoPlay();
  };
};

export default () => {
  $('.module--b7').each(function() {
    const $module = $(this);

    $module.imagesLoaded().always(function() {
      new Carousel( $module ).init();
    })
  });
}
